<div id="dialogContainer">
  <div id="dialogHeader">
    <strong>{{title}}</strong>
  </div>
  <div id="dialogContent">
    <ng-template #container></ng-template>
  </div>
</div>
